import { TooltipPrimeReact } from "@finanedi.es/storybook"
import { faShieldExclamation } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { TFunction } from "i18next"

interface ManipulatedFieldProps extends React.HTMLAttributes<HTMLSpanElement> {
  t?: TFunction
  isManipulated: boolean
  isFirstColumn?: boolean
}
export const ManipulatedField = ({
  t,
  isManipulated,
  isFirstColumn = false,
  className,
  ...props
}: ManipulatedFieldProps) => {
  return (
    <span
      className={`descripcionTooltip-${props?.id} tw-flex !tw-h-full tw-items-center data-[manipulated=true]:!tw-bg-danger-10 ${className}`}
      data-manipulated={isManipulated}
      {...props}
    >
      {isFirstColumn && isManipulated && (
        <>
          <FontAwesomeIcon
            icon={faShieldExclamation}
            className='tw-mr-2 tw-text-danger-20'
          />

          <TooltipPrimeReact
            id={`descripcionTooltip-${props?.id}`}
            target={`.descripcionTooltip-${props?.id}`}
            position='left'
          >
            <div className='tw-flex tw-flex-col'>
              <p className='tw-text-ellipsis tw-truncate !tw-text-sm'>
                {t?.("tickets.table.inconsistencyDetected")}
              </p>
            </div>
          </TooltipPrimeReact>
        </>
      )}
      {isFirstColumn && !isManipulated && <span className='tw-mr-6' />}
      {props.children}
    </span>
  )
}
